interface IDefaultOptions {
    tileUrl: string;
    attribution: string;
    attributionPrefix: string;
    tileSize: number;
    tileCrossOrigin: boolean;
    singleFloorHeight: number;
    defaultMinZoom?: number;
    defaultMaxZoom?: number;
    baseMapZoom?: number;
}

let defaultOptions: IDefaultOptions = {
    tileUrl: "",
    attribution: `&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>`,
    attributionPrefix: `<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>`,
    tileSize: 0,
    tileCrossOrigin: true,
    singleFloorHeight: 0.0000075,
    baseMapZoom: 10
};

export const getDefaultOptions = () => {
    if (!defaultOptions.tileUrl) {
        throw new Error("`tileUrl` has not been configured properly, please use `setDefaultOptions`.");
    }

    if (!defaultOptions.tileSize) {
        throw new Error("`tileSize` has not been configured properly, please use `setDefaultOptions`.");
    }

    return defaultOptions;
};

export const setDefaultOptions = (newOptions: Partial<IDefaultOptions>) => {
    defaultOptions = {
        ...defaultOptions,
        ...newOptions
    };
};
